import type { ButtonHTMLAttributes } from "react";

import classNames from "classnames";

import styles from "./Button.module.css";

type ButtonProps = {
    children: React.ReactNode;
    disabled?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function Button({ children, className, disabled, type = "button", ...props }: ButtonProps) {
    return (
        <button
            {...props}
            className={classNames(styles.button, className, { [styles.button__disabled]: disabled })}
            type={type}
        >
            {children}
        </button>
    );
}
